import { gql } from "@apollo/client";

export const RECORD_WRONG_ANSWER = gql`
  mutation RecordWrongAnswer($inputs: RecordWrongAnswerInput!) {
    recordWrongAnswer(inputs: $inputs) {
      status
      success
      message
      wrongAnswerItem {
        id
        userId
        booksetId
        bookId
        unitId
        sectionId
        pageId
        itemType
        correctText
        studentText
        questionStyle
        questionStyleType
        timesWrong
        timesCorrect
        nextReviewAt
        isMastered
      }
    }
  }
`;

export const RECORD_CORRECT_ANSWER = gql`
  mutation RecordCorrectAnswer($inputs: RecordCorrectAnswerInput!) {
    recordCorrectAnswer(inputs: $inputs) {
      status
      success
      message
      wrongAnswerItem {
        id
        timesWrong
        timesCorrect
        isMastered
        nextReviewAt
      }
    }
  }
`;

export const GET_WRONG_ITEMS_DUE_FOR_REVIEW = gql`
  query GetWrongItemsDueForReview($inputs: GetDueForReviewInput!) {
    getWrongItemsDueForReview(inputs: $inputs) {
      success
      message
      count
      items {
        id
        correctText
        studentText
        itemType
        questionStyle
        questionStyleType
        pageId
        sectionId
        unitId
        bookId
        timesWrong
        timesCorrect
        nextReviewAt
        isMastered
      }
    }
  }
`;

export const GET_RANDOM_WRONG_ITEMS = gql`
  query GetRandomWrongItems($inputs: GetRandomWrongItemsInput!) {
    getRandomWrongItems(inputs: $inputs) {
      success
      message
      count
      items {
        id
        correctText
        studentText
        itemType
        questionStyle
        questionStyleType
        pageId
        sectionId
        unitId
        bookId
        timesWrong
        timesCorrect
      }
    }
  }
`;
